import script from "./DiscussionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscussionsView.vue?vue&type=script&setup=true&lang=js"

import "./DiscussionsView.vue?vue&type=style&index=0&id=cb71dff0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb71dff0"]])

export default __exports__